// @ts-nocheck
import * as React from 'react';
// Pipeline — left column of the console. Parent enquiry list with filters.

import { useState } from 'react';
import Avatar from '../components/common/Avatar';
import StatusDot from '../components/common/StatusDot';
import SourceBadge from '../components/common/SourceBadge';
import './Pipeline.css';

export default function Pipeline({ parents, activeId, onSelect, demosByParent, isLoading, error, onRetry, loadingLeadId, detailError }) {
  const counts = parents.reduce((acc, p) => { acc[p.status] = (acc[p.status] || 0) + 1; return acc; }, {});
  const [filter, setFilter] = useState("all");
  const list = filter === "all" ? parents : parents.filter((p) => p.status === filter);

  return (
    <section className="A-col A-col--pipeline">
      <header className="A-pipe-head">
        <div>
          <div className="eyebrow">Today · Live Pipeline</div>
          <div className="A-pipe-title">
            <span>{parents.length} parent enquiries</span>
            <span className="livedot" title="Real-time" />
          </div>
        </div>
        <button className="A-pipe-icon" title="New enquiry">
          <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
        </button>
      </header>

      <div className="A-pipe-filters">
        {[
          { id: "all", l: "All", n: parents.length },
          { id: "new", l: "New", n: counts.new || 0 },
          { id: "in-demo", l: "In demo", n: counts["in-demo"] || 0 },
          { id: "considering", l: "Considering", n: counts.considering || 0 },
        ].map((f) => (
          <button
            key={f.id}
            className={"A-pipe-filter " + (filter === f.id ? "is-on" : "")}
            onClick={() => setFilter(f.id)}
          >
            {f.l} <span className="A-pipe-filter__n">{f.n}</span>
          </button>
        ))}
      </div>

      <div className="A-pipe-list">
        {isLoading && <div className="A-pipe-skeleton-list" role="status" aria-label="Loading admission leads">
          {Array.from({ length: 6 }).map((_, index) => (
            <div className="A-pcard-skeleton" key={index} aria-hidden="true">
              <span className="A-skeleton A-pcard-skeleton__avatar" />
              <span className="A-pcard-skeleton__body">
                <span className="A-skeleton A-pcard-skeleton__line A-pcard-skeleton__line--name" />
                <span className="A-skeleton A-pcard-skeleton__line A-pcard-skeleton__line--child" />
                <span className="A-skeleton A-pcard-skeleton__line A-pcard-skeleton__line--meta" />
              </span>
            </div>
          ))}
        </div>}
        {!isLoading && error && <div className="A-pipe-state A-pipe-state--error" role="alert">
          <span>{error}</span>
          <button type="button" onClick={onRetry}>Retry</button>
        </div>}
        {!isLoading && !error && detailError && <div className="A-pipe-detail-error" role="alert">{detailError}</div>}
        {!isLoading && !error && list.length === 0 && <div className="A-pipe-state">No enquiries found.</div>}
        {list.map((p) => {
          const triggered = (demosByParent[p.id] || []).length;
          const active = p.id === activeId;
          return (
            <button
              key={p.id}
              className={"A-pcard " + (active ? "is-active " : "") + (loadingLeadId === p.id ? "is-loading" : "")}
              onClick={() => onSelect(p.id)}
              aria-busy={loadingLeadId === p.id}
            >
              <Avatar p={p} size={36} />
              <div className="A-pcard__body">
                <div className="A-pcard__row1">
                  <span className="A-pcard__name">{p.name}</span>
                  <span className="A-pcard__time">{loadingLeadId === p.id ? 'Loading…' : p.enquiredAgo}</span>
                </div>
                <div className="A-pcard__row2">
                  <span className="A-pcard__child">{p.child} · {p.grade}</span>
                </div>
                <div className="A-pcard__row3">
                  <StatusDot status={p.status} />
                  <SourceBadge source={p.source} />
                  <span className="A-pcard__demos" title="Demos triggered">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="6 4 20 12 6 20 6 4" /></svg>
                    {triggered}
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <footer className="A-pipe-foot">
        <div className="A-pipe-foot__row">
          <span className="A-pipe-foot__label">Today's demos</span>
          <strong className="A-pipe-foot__value">{Object.values(demosByParent).reduce((total, demos) => total + demos.length, 0)}</strong>
        </div>
        <div className="A-pipe-foot__row">
          <span className="A-pipe-foot__label">Conversions</span>
          <strong className="A-pipe-foot__value">{counts.decided || 0}</strong>
        </div>
      </footer>
    </section>
  );
}
